import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import {AmlKycContact} from '../../schema-types/AmlKycContact';

type Props = {
  open: boolean;
  contacts: AmlKycContact[];
  onClose: () => void;
  onAddInformation: (contactId: string) => void;
};

const missingSummary = (contact: AmlKycContact) =>
  `${contact.amlKycMissingFields.length} of ${
    contact.amlKycRequiredFields.length
  } missing: ${contact.amlKycMissingFields.join(', ')}`;

// Shown on every Overview visit until each holder's gaps are filled.
export const AmlKycMissingPrompt: React.FC<Props> = ({
  open,
  contacts,
  onClose,
  onAddInformation,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogContent>
      <DialogContentText variant="subtitle1" mb={2}>
        There is additional information required before you can submit any instructions
      </DialogContentText>
      <Stack divider={<Divider flexItem />} spacing={1.5}>
        {contacts.map((contact) => {
          const name = contact.simplifiedName || 'Contact';
          return (
            <Box
              key={contact.id}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={2}
            >
              <Box>
                <Typography fontWeight={600}>{name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {missingSummary(contact)}
                </Typography>
              </Box>
              <Button
                size="small"
                variant="contained"
                color="primary"
                sx={{flexShrink: 0}}
                aria-label={`Add information for ${name}`}
                onClick={() => onAddInformation(contact.id)}
              >
                Add information
              </Button>
            </Box>
          );
        })}
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="secondary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);
